import { useEffect } from 'react';
import { pushThemeColorOverride } from '../services/ThemeService';

/** Keep iOS Safari/PWA chrome in step with the currently mounted page. */
export default function usePageThemeColor(colors) {
  // Note covers expose a raw top color specifically for the image edge. Use
  // it for both iOS light/dark status-area slots so the Dynamic Island/Safari
  // chrome matches the artwork's top edge instead of a lightness-adjusted
  // page background.
  const top = colors?.top || colors?.themeColorTop || null;
  const light = top || colors?.light || colors?.themeColorLight || null;
  const dark = top || colors?.dark || colors?.themeColorDark || null;

  useEffect(() => {
    if (!light || !dark) return undefined;
    return pushThemeColorOverride({ light, dark });
  }, [light, dark]);
}
